<template>
  <div class="dashboard  cadfm-flexitem-fixed">

    <b-col>
      <b-card-group deck class="mb-5" >
          <CardComponent v-show="d_widgetsSettings.MyTasks" name="MyTasks" type="table" :lang="lang.Cards.MyTasks"></CardComponent>
          <span v-if="appConf.status.isLM && isAgent">
              <CardComponent v-show="d_widgetsSettings.LibStatuses" name="LibStatuses" type="table" :lang="lang.Cards.LibStatuses">
              </CardComponent>
            </span>
          <span  v-if="appConf.status.isPM">
          <CardComponent v-show="d_widgetsSettings.ActiveParts" name="ActiveParts" type="chart" :lang="lang.Cards.ActiveParts"></CardComponent>
          </span>
          <span  v-if="appConf.status.isPM">
          <CardComponent v-show="d_widgetsSettings.PendingParts" name="PendingParts" type="chart" :lang="lang.Cards.PendingParts"></CardComponent>
          </span>
          <span  v-if="appConf.status.isPM">      
            <CardComponent v-show="d_widgetsSettings.EndOfParts" name="EndOfParts" type="table" :lang="lang.Cards.EndOfParts"></CardComponent>
            </span>
          <span  v-if="appConf.status.isLM">
          <CardComponent v-show="d_widgetsSettings.ActiveLibraries" name="ActiveLibraries" type="chart" :lang="lang.Cards.ActiveLibraries"></CardComponent>
          </span>
          <span  v-if="appConf.status.isLM">
          <CardComponent v-show="d_widgetsSettings.PendingLibraries" name="PendingLibraries" type="chart" :lang="lang.Cards.PendingLibraries"></CardComponent>
          </span>    
          
          
          <span  v-if="appConf.status.isPM">     
          <CardComponent v-show="d_widgetsSettings.RoHSParts" name="RoHSParts" type="chart" :lang="lang.Cards.RoHSParts"></CardComponent>
          </span>
      </b-card-group>
    </b-col>

    



 </div>
</template>

<script>

import CardComponent from "@/components/shared/CardComponent"
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components:{

    CardComponent,
    
  },
  data () {
    return {
     

    }
  },
  props:{
      
    lang: Object
  },
  computed:{
    ...mapGetters([
      'appConf',
      'isAgent'
      ]),
    d_widgetsSettings(){
      return this.$store.getters.d_widgetsSettings;
    }
    

  },
  created () {
    
  },
  updated() {
       
    
  },
  methods:{
    
  }
}
</script>


<style scoped>
  .dashboard{


  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DashboardWidgets/Left/Content/Content.vue